import React, { Component } from 'react';
import { Panel, Button } from 'react-bootstrap';
import { labels } from '../../../helpers';
import '../../../content/css/PortfolioAnalysis/InsightComponent.css';
import Chart from './Chart';

export default class InsightComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: '',
            data: {},
            options: {}
        }
    }

    componentDidMount() {
        this.update();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.data !== prevProps.data) {
            this.update();
        }
    }

    isNumeric = (string) => Number.isFinite(+string);

    update = () => {

        //Switch on the type of insight from props.type
        switch (this.props.type) {
            case "Warranty": this.setToLimitationOfLiability(); break;
            case "WarrantyPeriod": this.setToWarrantyPeriod(); break;
            case "LiabilityCap": this.setToLiabilityCap(); break;
            case "LimitationOfLiability": this.setToLimitationOfLiability(); break;
            case "LiabilityForDelay": this.setToLiabilityForDelay(); break;
            case "LiabilityForDefects": this.setToLiabilityForDefects(); break;
            case "Indemnities": this.setToLimitationOfLiability(); break;
            case "ForceMajeure": this.setToForceMajeure(); break;
            case "ExclusionConsequentialDamages": this.setToExclusionConsequentialDamages(); break;
            case "PriceAdjustment": this.setToPriceAdjustments(); break;
            case "FixedPrices": this.setToFixedPrices(); break;
            case "PaymentTerm": this.setToPaymentTerms(); break;
            case "LatePaymentInterest": this.setToLatePaymentInterest(); break;
            case "NoTransferIPR": this.setToNoTransferIPR(); break;
            case "GoverningLaw": this.setToGoverningLaw(); break;
            case "Arbitration": this.setToArbitration(); break;
            case "Court": this.setToCourt(); break;
            case "Forecasts": this.setToForecasts(); break;
            case "Confidentiality": this.setToConfidentiality(); break;
            case "MultiConfidentiality": this.setToMultiConfidentiality(); break;
            case "MultiTermination": this.setToMultiConfidentiality(); break;
            case "Amendments": this.setToAmendments(); break;
            case "EntireAgreement": this.setToEntireAgreements(); break;
            case "AgreementTerm": this.setToAgreementTerm(); break;
            case "NoticePeriod": this.setToNoticePeriod(); break;
        }
    }

    groupBy = (xs, key) => {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    getUniqueItemsByDocumentId = (items) => items.reduce((acc, item) => {
        if (!acc.find(i => i.documentId === item.documentId)) {
            acc.push(item);
        }
        return acc;
    }, []);

    getPeriodInDays = (period, periodType) => {
        if (!period || period !== period)
            return period;

        switch (periodType) {
            case "day": return period;
            case "week": return period * 7;
            case "month": return period * 30;
            case "year": return period * 365;
        }

        return period;
    }

    setToDefaultPeriod = (min, max) => {

        let type = 'bar';
        let opacity = '0.8';
        let colorOkay = `rgba(54, 162, 235, ${opacity})`;
        let colorBad = `rgba(255, 99, 132, ${opacity})`;
        let borderColorOkay = `rgba(54, 162, 235, 1)`;
        let borderColorBad = `rgba(255, 99, 132, 1)`;

        let insightItems = this.props.data.map(x => {
            let value = x.values ? parseInt(x.values['period_num']) : 0;
            let periodType = x.values ? x.values['period_type'] : 0;
            let label = x.label;
            if (label !== "Missing") {
                if (!this.isNumeric(value)) label = "Others";
                else if (periodType == 0) label = "Others";//`${value} days`;
            }
            return {
                ...x,
                label,
                value,
                periodType
            }
        });

        let groups = this.groupBy(insightItems, 'label');
        let data = Object.entries(groups).map(([label, items]) => {
            const uniqueItems = this.getUniqueItemsByDocumentId(items);
            let value = this.getPeriodInDays(items[0].value, items[0].periodType);
            let sortOrder = value === value ? value : 0;
            let color = value >= min && value <= max ? colorOkay : colorBad;
            let borderColor = value >= min && value <= max ? borderColorOkay : borderColorBad;
            let count = uniqueItems.filter(x => x.wasFound).length;

            //If no value, mark as not found.
            if (value === 0) {
                count += uniqueItems.filter(x => !x.wasFound).length;
                color = this.getColor(2);
                borderColor = this.getBorderColor(2);
            }
            return { label, sortOrder, value: count, color, borderColor };
        });

        let options = {
            legend: {
                display: false
            },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        };

        this.updateChart(type, this.props.type, data, options);
    }

    setToWarrantyPeriod = () => {

        this.setToDefaultPeriod(0, 1000);
    }

    setToPaymentTerms = () => {

        this.setToDefaultPeriod(0, 30);
    }

    setToNoticePeriod = () => {

        this.setToDefaultPeriod(60, 10000);
    }

    setToGoverningLaw = () => {

        let type = 'pie';

        let groups = Object.entries(this.groupBy(this.props.data, 'label'));
        groups.sort((a, b) => b[1].length - a[1].length);
        let data = groups.map(([label, items], index) => {
            const uniqueItems = this.getUniqueItemsByDocumentId(items);
            if (label == "0") label = "Missing";
            return { label, value: uniqueItems.length, color: this.getColor(index), borderColor: this.getBorderColor(index) };
        });
        data = data.filter(x => this.props.filter.includes(x.label));

        //If too many labels/countries, group the 'tail' under 'Others'.
        const MAX_LABELS = 15;
        if (data.length > MAX_LABELS) {
            let top = data.slice(0, MAX_LABELS);
            let restCount = data.slice(MAX_LABELS).reduce((acc, data) => acc + parseInt(data.value), 0);
            let others = top.filter(x => x.label === "Others");
            if (!others || others.length === 0) {
                let rest = { label: "Others", value: restCount, color: this.getColor(11), borderColor: this.getBorderColor(11) };
                data = [...top, rest];
            }
            else {
                others[0].value += restCount;
                data = top;
            }
        }

        let options = {};

        this.updateChart(type, 'Share of countries', data, options);
    }

    setToLiabilityCap = () => { this.setToWarrantyPeriod(); }
    setToLimitationOfLiability = () => {
        let type = 'pie';

        const uniqueData = this.props.data.filter((item, index, self) =>
            index === self.findIndex((t) => t.documentId === item.documentId)
        );

        let groups = this.groupBy(uniqueData, 'label');
        let data = Object.entries(groups).map(([label, items]) => {
            let c = label == 'Yes' ? this.getColor(1) : this.getColor(0);
            let bc = label == 'Yes' ? this.getBorderColor(1) : this.getBorderColor(0);
            return { label, sortOrder: label == 'Yes' ? 0 : 1, value: items.length, color: c, borderColor: bc };
        });

        let options = {
        };

        this.updateChart(type, 'asd', data, options);
    }
    setToLiabilityForDelay = () => { this.setToWarrantyPeriod(); }
    setToLiabilityForDefects = () => {
        let type = 'horizontalBar';
        let opacity = '0.8';
        let color = `rgba(54, 162, 235, ${opacity})`;
        let borderColor = `rgba(54, 162, 235, 1)`;

        let groups = this.groupBy(this.props.data, 'code');
        let data = Object.entries(groups).map(([label, items]) => {
            let found = items.filter(x => x.wasFound);
            return { label, value: found.length, color: this.getColor(1), borderColor: this.getBorderColor(1) };
        });

        /*let data = [
            { label: 'Remedial measures', value: this.getRandomNumber(30), color: this.getColor(1), borderColor: this.getBorderColor(1) },
            { label: 'Replacement', value: this.getRandomNumber(30), color: this.getColor(1), borderColor: this.getBorderColor(1) },
            { label: 'Reduce Purchase Price', value: this.getRandomNumber(30), color: this.getColor(1), borderColor: this.getBorderColor(1) },
            { label: 'Termination', value: this.getRandomNumber(30), color: this.getColor(1), borderColor: this.getBorderColor(1) },
            { label: 'Refund Purchase price', value: this.getRandomNumber(30), color: this.getColor(1), borderColor: this.getBorderColor(1) },
            { label: 'Damages', value: this.getRandomNumber(30), color: this.getColor(1), borderColor: this.getBorderColor(1) }
        ];*/

        let options = {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        };

        this.updateChart(type, 'asd', data, options);
    }
    setToForceMajeure = () => {
        let type = 'pie';

        let onlyFM = 0, FMInclPandemics = 0, missing = 0;
        let groups = this.groupBy(this.props.data, 'documentId');
        for (const [id, items] of Object.entries(groups)) {
            let hasFM = items.filter(x => x.code == "F1" && x.wasFound).length > 0;
            let hasPandemics = items.filter(x => x.code == "Pandemics" && x.wasFound).length > 0;
            if (hasFM && hasPandemics) FMInclPandemics++;
            else if (hasFM) onlyFM++;
            else missing++;
        };

        let data = [
            { label: 'Only force majeure', value: onlyFM, color: this.getColor(2), borderColor: this.getBorderColor(2) },
            { label: 'Force majeure incl. pandemics', value: FMInclPandemics, color: this.getColor(1), borderColor: this.getBorderColor(1) },
            { label: 'No', value: missing, color: this.getColor(0), borderColor: this.getBorderColor(0) }
        ];

        let options = {
        };

        this.updateChart(type, 'asd', data, options);
    }
    setToMultiConfidentiality = () => {
        let type = 'horizontalBar';

        let groups = this.groupBy(this.props.data, 'code');
        let data = Object.entries(groups).map(([label, items]) => {
            let isMissingGroup = label === "null";
            let found = items.filter(x => x.wasFound);
            let value = found.length;
            label = labels.getConceptName(label);
            let color = this.getColor(1);
            let borderColor = this.getBorderColor(1);

            if (isMissingGroup) {
                label = "Missing";
                value = items.length - found.length;
                color = this.getColor(2);
                borderColor = this.getBorderColor(2);
            }

            return { label, value, color, borderColor };
        });

        let options = {
            legend: {
                display: false
            },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        };

        this.updateChart(type, '', data, options);
    }
    setToExclusionConsequentialDamages = () => { this.setToLimitationOfLiability(); }
    setToPriceAdjustments = () => { this.setToLimitationOfLiability(); }
    setToFixedPrices = () => { this.setToLimitationOfLiability(); }
    setToLatePaymentInterest = () => { this.setToWarrantyPeriod(); }
    setToNoTransferIPR = () => { this.setToLimitationOfLiability(); }
    setToArbitration = () => { this.setToLimitationOfLiability(); }
    setToCourt = () => { this.setToLimitationOfLiability(); }
    setToForecasts = () => { this.setToLimitationOfLiability(); }
    setToConfidentiality = () => { this.setToLimitationOfLiability(); }
    setToAmendments = () => { this.setToLimitationOfLiability(); }
    setToEntireAgreements = () => { this.setToLimitationOfLiability(); }
    setToAgreementTerm = () => { this.setToDefaultPeriod(0, 370); }

    updateChart = (type, label, data, options) => {
        data.sort((a, b) => a.sortOrder - b.sortOrder);
        let formattedData = {
            labels: data.map(x => x.label),
            datasets: [{
                label: label,
                data: data.map(x => x.value),
                backgroundColor: data.map(x => x.color),
                borderColor: data.map(x => x.borderColor),
                borderWidth: 1
            }]
        };

        this.setState({ type, data: formattedData, options });
    }

    getRandomNumber = (max) => Math.round(Math.random() * max);
    getRandomData = (length, max) => [...new Array(length)].map(() => Math.round(Math.random() * max));

    getColor = (i) => {
        switch (i) {
            case 0: return 'rgba(255, 99, 132, 0.8)';
            case 1: return 'rgba(54, 162, 235, 0.8)';
            case 2: return 'rgba(255, 206, 86, 0.8)';
            case 3: return 'rgba(75, 192, 192, 0.8)';
            case 4: return 'rgba(153, 102, 255, 0.8)';
            case 5: return 'rgba(255, 159, 64, 0.8)';
            case 6: return 'rgba(200, 110, 80, 0.8)';
            case 7: return 'rgba(23, 170, 100, 0.8)';
            case 8: return 'rgba(150, 130, 100, 0.8)';
            case 9: return 'rgba(100, 40, 140, 0.8)';
            case 10: return 'rgba(50, 75, 160, 0.8)';
            case 11: return 'rgba(200, 200, 200, 0.8)';
            case 12: return 'rgba(150, 150, 200, 0.8)';
            case 13: return 'rgba(200, 180, 200, 0.8)';
            case 14: return 'rgba(20, 200, 150, 0.8)';
            default: 'rgba(255, 99, 132, 0.8)';
        }
    }

    getBorderColor = (i) => {
        switch (i) {
            case 0: return 'rgba(255, 99, 132, 1)';
            case 1: return 'rgba(54, 162, 235, 1)';
            case 2: return 'rgba(255, 206, 86, 1)';
            case 3: return 'rgba(75, 192, 192, 1)';
            case 4: return 'rgba(153, 102, 255, 1)';
            case 5: return 'rgba(255, 159, 64, 1)';
            case 6: return 'rgba(200, 110, 80, 1)';
            case 7: return 'rgba(23, 170, 100, 1)';
            case 8: return 'rgba(150, 130, 100, 1)';
            case 9: return 'rgba(100, 40, 140, 1)';
            case 10: return 'rgba(50, 75, 160, 1)';
            case 11: return 'rgba(200, 200, 200, 1)';
            case 12: return 'rgba(150, 150, 200, 0.8)';
            case 13: return 'rgba(200, 180, 200, 0.8)';
            case 14: return 'rgba(20, 200, 150, 0.8)';
            default: 'rgba(255, 99, 132, 1)';
        }
    }

    render() {
        return (
            <div className="insight-container">
                <Panel className="insight-panel">
                    <h3>{this.props.title}</h3>
                    <span>{this.props.description}</span>
                    <Chart
                        type={this.state.type}
                        data={this.state.data}
                        options={this.state.options} />
                </Panel>
                <Panel className="playbook-panel">
                    <h3>Playbook</h3>
                    <p>{this.props.playbookText}</p>
                    {!this.props.isSelected &&
                        <Button bsStyle="primary" onClick={() => this.props.onSelect(this.props.type)}>View Documents</Button>
                    }
                    {this.props.isSelected &&
                        <Button bsStyle="primary" onClick={() => this.props.onSelect("")}>Back to Insights</Button>
                    }
                </Panel>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AnalysisReports/Insights/InsightComponent.js